import { Fragment } from "react";
import BoxTitle from "../../../TEMPLATE/components/box/title/BoxTitle";
// import { diavLink } from "../../hardCodeData/DATA";
import { Link } from "react-router-dom";

import * as Icon from "../../../TEMPLATE/components/Map/smartiscity/Icons";

const ThreeDimensions = () => {
  return (
    <Fragment>
      <BoxTitle
        icon={Icon.threeDGismoDark}
        title={"3D ΑΝΑΠΑΡΑΣΤΑΣΕΙΣ"}
        internalLink="/3d"
        infoContext={"info"}
        element={
          <i
            id="draggable"
            className="im im-icon-Double-Tap"
            style={{ fontSize: "32px", minWidth: "32px", cursor: "pointer" }}
          />
        }
      />
      <p
        style={{
          marginTop: 10,
          // color: "white",
          fontSize: "14px",
          textAlign: "center",
          lineHeight: "1.5",
        }}
      >
        Εξερευνήστε τις τρισδιάστατες αναπαραστάσεις των σημείων ενδιαφέροντος
        του Δήμου
      </p>
      <button
        type={"button"}
        style={{
          width: 180,
          height: 44,
          marginLeft: "calc((100% - 180px ) /2)",
          marginTop: 20,
          borderRadius: "30px",
          border: "none",
          cursor: "pointer",
        }}
        // onClick={() => window.open(diavLink, "_self")}
      >
        <Link
          to="/3d"
          style={{ fontWeight: "700", fontSize: "14px", color: "#F81D12" }}
        >
          Εξερεύνηση
        </Link>
      </button>
    </Fragment>
  );
};
export default ThreeDimensions;
